import { useEffect, useState, useRef } from "react";
import MobileCertificate from "./MobileCertificate";
import DesktopCertificate from "./DesktopCertificate";

const overlays = [
  { id: "spartan", label: "Spartan", image: "/images/spartan-desktop.webp" },
  { id: "bull", label: "Bull", image: "/images/bull-desktop.webp" },
  { id: "chart", label: "Chart", image: "/images/chart-desktop.webp" },
  { id: "bear", label: "Bear", image: "/images/bear-desktop.webp" },
];

const CertificateModal = ({ onClose }) => {
  const [selectedOverlay, setSelectedOverlay] = useState("spartan");
  const [downloading, setDownloading] = useState(false);
  const [customText, setCustomText] = useState(
    "Join the PropFunding Challenge free. Pass first, then pay."
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    overlays.forEach((overlay) => {
      const img = new Image();
      img.src = overlay.image;
    });
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const certificateData = {
    trader: "Leotan",
    rank: 5,
    total: 80,
    status: "Passed",
    selectedOverlay,
    customText,
  };

  // 🔥 THIS is the exporter ref
  const desktopRef = useRef(null);

  const sharedProps = {
    data: certificateData,
    onClose,
    selectedOverlay,
    setSelectedOverlay,
    downloading,
    setDownloading,
    overlays,
    setCustomText,
  };

  return (
    <>
      {/* What user sees */}
      {isMobile ? (
        <MobileCertificate {...sharedProps} desktopRef={desktopRef} />
      ) : (
        <DesktopCertificate {...sharedProps} ref={desktopRef} />
      )}

      {/* Hidden Desktop Certificate (Export Engine) */}
      <div
        style={{
          position: "fixed",
          left: "-200vw",
          top: 0,
          pointerEvents: "none",
        }}
      >
        <DesktopCertificate {...sharedProps} ref={desktopRef} />
      </div>
    </>
  );
};

export default CertificateModal;
